import Vue from 'vue';
import LicenceAreaZones from '@/resources/licence-area-zones';
import normalize from '@/lib/normalize';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'licenceAreaZones';
const DEFAULT_STATE = {
  error: null,
  zones: null,
  zone: null
};

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },

  mutations: {
    parseResponseData(state, zones) {
      Vue.set(state, 'zones', zones);
    },
    parseZoneResponseData(state, response) {
      const zone = normalize(response);
      Vue.set(state, 'zone', zone);
    },
    setZones(state, zones) {
      Vue.set(state, 'zones', zones);
    },
    editZone(state, zone) {
      Vue.set(state, 'zone', zone);
    }
  },
  actions: {
    fetchAll({ commit }, { projectCode, licenceAreaCode, updateProjectsLicenceAreaZones }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      LicenceAreaZones({ projectCode, licenceAreaCode })
        .get()
        .then(
          response => {
            const zones = normalize(response.data);

            commit('parseResponseData', zones);
            if (updateProjectsLicenceAreaZones) {
              commit(
                'projects/updateProjectsLicenceAreaZones',
                { projectCode, licenceAreaCode, zones },
                { root: true }
              );
            }
            RootStateCommit(commit, 'stopLoading', MODULE_NAME);
          },
          () => {
            RootStateCommit(commit, 'setResponseError', MODULE_NAME);
          }
        );
    },
    fetch({ commit }, { projectCode, licenceAreaCode, zoneCode }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      LicenceAreaZones({ projectCode, licenceAreaCode, zoneCode })
        .get()
        .then(
          response => {
            commit('parseZoneResponseData', response.data);
            RootStateCommit(commit, 'stopLoading', MODULE_NAME);
          },
          () => {
            RootStateCommit(commit, 'setResponseError', MODULE_NAME);
          }
        );
    },
    update({ commit }, { projectCode, licenceAreaCode, zoneCode, data }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const res = LicenceAreaZones({ projectCode, licenceAreaCode, zoneCode }, data).patch();

      res.then(
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return res;
    },
    create({ commit }, { projectCode, licenceAreaCode, data }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const res = LicenceAreaZones({ projectCode, licenceAreaCode }, data).save();

      res.then(
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return res;
    },
    remove({ commit }, { projectCode, licenceAreaCode, zoneCode }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const res = LicenceAreaZones({ projectCode, licenceAreaCode, zoneCode }).delete();

      res.then(
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return res;
    }
  }
};
